import React, { useState } from "react"; // reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Button,
  Input,
  Spinner,
} from "reactstrap";
import OnlyHeader from "components/Layout/OnlyHeader.js";
import { useDispatch, useSelector } from "react-redux";
import { addNewUser } from "store/actions/authActions";
import { toast } from "react-toastify";
import { getAllRestaurant } from "store/actions/restaurantAction";
import { useEffect } from "react";
import { updateMerchant } from "store/actions/restaurantAction";
import { deleteRestaurant } from "store/actions/restaurantAction";
import AddMerchantModal from "components/Merchants/AddMerchantModal";
import EditMerchantModal from "components/Merchants/EditMerchantModal";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import Pagination from "components/shared/Pagination";
import { validatePassword } from "utils/ValidatePassword";

const Merchants = () => {
  const dispatch = useDispatch();
  const {
    restaurantsData,
    isDeleteLoading,
    isUpdateLoading,
    isLoading,
    restaurantsRestData,
  } = useSelector((state) => state.restaurant);
  const totalPages = restaurantsRestData?.nbPages || 0;
  const { loading } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    status: "",
    language: "",
    url: "",
    email: "",
    password: "",
    authType: "",
  });
  const [searchField, setSearchField] = useState("");
  const [hitsPerPage, setHitsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [errors, setErrors] = useState("");
  const [editId, setEditId] = useState("");
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const addtoggle = () => {
    setAddModal(!addModal);
    setShowPassword(false);
    setErrors("");
    setFormData({
      name: "",
      location: "",
      status: "",
      language: "",
      url: "",
      email: "",
      password: "",
      authType: "",
    });
  };
  const edittoggle = () => {
    setEditModal(!editModal);
  };
  const deletetoggle = () => {
    setDeleteModal(!deleteModal);
  };

  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    const validCharacters = /^[a-zA-Z@]*$/;
    if (validCharacters.test(inputValue) || inputValue === "") {
      setSearchField(inputValue);
    } else {
      toast.error("Only alphabets and '@' are allowed in search.");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const validationErrors = validatePassword(formData.password);

    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      setErrors("");
    }

    let obj = {
      name: formData.name,
      email: formData.email,
      location: formData.location,
      status: formData.status.toLowerCase(),
      language: formData.language,
      password: formData.password,
      type: "restaurant",
      subScriptionStatus: "subscribe",
      currency: "$",
      subscription: {},
      restaurantLogo: "",
      socialProfiles: [
        {
          type: "facebook",
        },
        {
          type: "instagram",
        },
        {
          type: "tiktok",
        },
        {
          type: "discord",
        },
        {
          type: "youtube",
        },
        {
          type: "website",
        },
        {
          type: "linktree",
        },
        {
          type: "linkedIn",
        },
        {
          type: "snapchat",
        },
        {
          type: "twiter",
        },
      ],
      storeTiming: [
        { day: "Monday", startTime: "", endTime: "" },
        { day: "Tuesday", startTime: "", endTime: "" },
        { day: "Wednesday", startTime: "", endTime: "" },
        { day: "Thursday", startTime: "", endTime: "" },
        { day: "Friday", startTime: "", endTime: "" },
        { day: "Saturday", startTime: "", endTime: "" },
        { day: "Sunday", startTime: "", endTime: "" },
      ],
    };
    setLoadingBtn(true);
    dispatch(
      addNewUser(
        obj,
        [],
        () => {
          setTimeout(() => {
            addtoggle();
            setFormData({
              name: "",
              location: "",
              status: "",
              language: "",
              url: "",
              email: "",
              password: "",
              authType: "",
            });
            dispatch(getAllRestaurant(searchField, hitsPerPage, currentPage));
            toast.success(
              "Merchant added successfully and verification email has been sent"
            );
            setLoadingBtn(false);
          }, 3000);
        },
        () => setLoadingBtn(false)
      )
    );
  };

  const handleUpdateRestaurant = (event) => {
    event.preventDefault();
    let obj = {
      name: formData.name,
      location: formData.location,
      status: formData.status,
      language: formData.language,
    };
    dispatch(
      updateMerchant(editId, obj, () => {
        edittoggle();
        toast.success("Merchant Updated SuccessFully");
        setFormData({
          name: "",
          location: "",
          status: "",
          language: "",
          url: "",
          email: "",
          password: "",
          authType: "",
        });
      })
    );
  };

  const HandleDeleteBtn = () => {
    setLoadingBtn(true);
    dispatch(
      deleteRestaurant(editId, () => {
        setTimeout(() => {
          deletetoggle();
          toast.success("Merchant Deleted SuccessFully");
          dispatch(getAllRestaurant(searchField, hitsPerPage, currentPage));
          setLoadingBtn(false);
        }, 3000);
      })
    );
  };

  useEffect(() => {
    setLoadingState(true);

    dispatch(
      getAllRestaurant(searchField, hitsPerPage, currentPage, () => {
        setLoadingState(false);
      })
    );
  }, [searchField, hitsPerPage, currentPage, dispatch]);
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="d-lg-flex  d-sm-block justify-content-between">
                <h3 className="mb-0 pt-2 col-lg-2 ">Merchants</h3>
                <Input
                  className="col-lg-3 mx-1 my-2 my-lg-0"
                  placeholder="Search by name or email"
                  value={searchField}
                  onChange={handleSearchChange}
                />
                <Input
                  className="col-lg-3 mx-1 my-2 my-lg-0"
                  type="select"
                  id="exampleCustomSelect"
                  name="customSelect"
                  value={hitsPerPage}
                  onChange={(e) => {
                    setHitsPerPage(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="5">Show Entries</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </Input>
                <Button
                  className="mb-0 col-lg-2"
                  color="primary"
                  onClick={addtoggle}
                >
                  Add
                </Button>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Merchant Name</th>
                    <th scope="col">Location</th>
                    <th scope="col">Email</th>
                    <th scope="col">Has Logged In</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && loadingState ? (
                    <tr>
                      <td colSpan="100%" className="text-center py-5">
                        <Spinner size="lg" color="primary" />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {restaurantsData?.length > 0 ? (
                        <>
                          {restaurantsData &&
                            restaurantsData.map((ele) => {
                              return (
                                <tr>
                                  <th scope="row">{ele?.name}</th>
                                  <td>
                                    {ele?.location ? ele?.location : "N/A"}
                                  </td>
                                  <td>{ele?.email}</td>
                                  <td>{ele?.firsttimelogin ? "Yes" : "No"}</td>
                                  <td>
                                    <Button
                                      className="btn-sm"
                                      color="primary"
                                      onClick={() => {
                                        setFormData({
                                          name: ele?.name,
                                          location: ele?.location,
                                          status: ele?.status,
                                          language: ele?.language,
                                          url: ele?.url,
                                          email: ele.email,
                                          authType: ele?.authType,
                                        });
                                        setEditId(ele.id);
                                        edittoggle();
                                      }}
                                    >
                                      Edit
                                    </Button>
                                    <Button
                                      className="btn-sm"
                                      color="danger"
                                      onClick={() => {
                                        setEditId(ele.id);
                                        deletetoggle();
                                      }}
                                    >
                                      Delete
                                    </Button>
                                    <Button className="btn-sm" color="success">
                                      <a
                                        href="https://nexteats-admin.web.app/auth/login"
                                        target="_blank"
                                        className="text-white"
                                        rel="noreferrer"
                                      >
                                        Login
                                      </a>
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-5">
                            No Merchant Added
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddMerchantModal
          formData={formData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          addModal={addModal}
          addtoggle={addtoggle}
          loading={loading}
          loadingBtn={loadingBtn}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          errors={errors}
        />
        <EditMerchantModal
          formData={formData}
          isLoading={isUpdateLoading}
          handleInputChange={handleInputChange}
          handleUpdateRestaurant={handleUpdateRestaurant}
          editModal={editModal}
          edittoggle={edittoggle}
        />
        <ConfirmationModal
          title="Delete Merchant"
          text="Are you sure you want to delete detail of this merchant?"
          isOpen={deleteModal}
          toggle={deletetoggle}
          isLoading={isDeleteLoading}
          onConfirmation={HandleDeleteBtn}
          loadingBtn={loadingBtn}
        />
      </Container>
    </>
  );
};

export default Merchants;
